import React from 'react';

export const LiveBadge: React.FC = () => {
    return (
        <div className="bg-[#FD852F] rounded-[8px] px-[14px] py-[5px] fit-content text-[10px] tablet:text-[16px] tablet:min-w-[62px] max-w-[64px] shrink-0">
            LIVE
        </div>
    );
};
